import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import * as ANY from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/AccidentNewYork';
import * as GANY from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/GroupAccidentNewYork';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import States from 'ApplicationEntry/models/States';
import {CaseDetails} from 'ApplicationEntry/models/CaseDetails';
import PackageSelect from '../PackageSelect';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import * as ANYActions from 'ApplicationEntry/ducks/ProductsRiders/accidentNewYork';

type AccidentNewYorkProps = {
  caseDetails: CaseDetails;
  accidentNewYork: ANY.AccidentNewYork;
};

const AccidentNewYork = (props: AccidentNewYorkProps) => {
  const dispatch = useDispatch();
  const {
    packageName,
    planType,
    calculatedPremium,
    cwa,
    policyNumber,
    replacement,
    section125,
    baseUnits,
    jStamp,
    situsState,
    plan,
    packageList,
  } = props.accidentNewYork as GANY.GroupAccidentNewYork;
  const [planBlurred, setPlanBlurred] = useState(false);
  const [situsLabel, setSitusLabel] = useState<HTMLLabelElement | null>();
  const [planTypeBlurred, setPlanTypeBlurred] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [planLabel, setPlanLabel] = useState<HTMLLabelElement | null>();
  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const showPlanError = planBlurred && plan.key === 'Empty';

  return (
    <>
      <div className="product-riders-section__policy-type" id="accident-new-york-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanLabel} id="accident-new-york-plan-label">
                    Plan
                  </InputLabel>
                  <Select
                    labelId="accident-new-york-label-plan"
                    labelWidth={planLabel?.clientWidth}
                    id="accident-new-york-plan"
                    value={plan.key === 'Empty' ? '' : plan.value}
                    onBlur={() => setPlanBlurred(true)}
                    onChange={event => {
                      dispatch(ANYActions.changePlan(event.target.value as string));

                      const caseNumber =
                        props.caseDetails.key === 'ValidGroupCaseDetails' ? props.caseDetails.caseNumber.Data : '';

                      dispatch(ANYActions.getGroupAccidentNYPackages(caseNumber, event.target.value as string));
                    }}
                  >
                    {GANY.plans.map(plan => (
                      <MenuItem value={plan} key={plan}>
                        {plan}
                      </MenuItem>
                    ))}
                  </Select>
                  {showPlanError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
              <PackageSelect
                packageName={packageName}
                packageList={packageList}
                changePackageAction={ANYActions.changePackage}
                handlePackageItems={(packageItem: object) =>
                  dispatch(ANYActions.changeBaseUnits(packageItem['baseUnits']))
                }
              />
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                  <InputLabel
                    id="accident-new-york-units-label"
                    className={'product-riders-section__policy-type__form__row--label'}
                  >
                    Base Units
                  </InputLabel>
                  <Select
                    labelId="accident-new-york-label-units"
                    id="accident-new-york-base-units"
                    value={baseUnits.key === 'Empty' ? '' : parseFloat(baseUnits.value)}
                    onChange={event => dispatch(ANYActions.changeBaseUnits(event.target.value as string))}
                    disabled
                    displayEmpty
                  >
                    {GANY.baseUnits.map((baseUnit: number) => (
                      <MenuItem value={baseUnit} key={baseUnit}>
                        {baseUnit}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="accident-new-york-j-stamp"
                      disabled
                      checked={jStamp}
                    />
                  }
                  label={<Typography>J-Stamp</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanTypeError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanTypeLabel} id="accident-new-york-plantype-label">
                    Plan Type
                  </InputLabel>
                  <Select
                    labelId="accident-new-york-label-plantype"
                    labelWidth={planTypeLabel?.clientWidth}
                    id="accident-new-york-plantype"
                    value={planType.key === 'Empty' ? '' : planType.value}
                    onBlur={() => setPlanTypeBlurred(true)}
                    onChange={event => {
                      dispatch(ANYActions.changePlanType(event.target.value as string));
                    }}
                  >
                    <MenuItem value="IND">Individual</MenuItem>
                    <MenuItem value="FAMILY">Family</MenuItem>
                    <MenuItem value="EMP+SPOUSE">Emp+Spouse</MenuItem>
                    <MenuItem value="EMP+CHILDREN">Emp+Children</MenuItem>
                  </Select>
                  {showPlanTypeError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                  <InputLabel ref={setSitusLabel} id="accident-new-york-situs-label">
                    Situs State
                  </InputLabel>
                  <Select
                    labelId="accident-new-york-label-situs"
                    labelWidth={situsLabel?.clientWidth}
                    id="accident-new-york-situs"
                    value={situsState.key === 'Empty' ? '' : situsState.value}
                    onChange={e => {
                      dispatch(BAActions.changeState(e.target.value as string));
                      dispatch(ANYActions.changeSitusState(e.target.value as string));
                    }}
                    displayEmpty
                  >
                    {States.map(stateCode => (
                      <MenuItem key={stateCode} value={stateCode}>
                        {stateCode}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="accident-new-york-premium"
                  label="Premium"
                  variant="outlined"
                  placeholder="Enter Premium"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={calculatedPremium.value}
                  onChange={event => {
                    dispatch(ANYActions.changePremium(event.target.value as string));
                    dispatch(ANYActions.changeCalculatedPremium(event.target.value as string));
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="accident-new-york-cwa"
                  label="CWA"
                  variant="outlined"
                  placeholder="Enter CWA"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={cwa.value}
                  onChange={event => dispatch(ANYActions.changeCWA(event.target.value as string))}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="accident-new-york-section-125"
                      checked={section125}
                      onChange={() => dispatch(ANYActions.changeSection125(!section125))}
                    />
                  }
                  label={<Typography>Section 125</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="accident-new-york-replacement"
                      checked={replacement}
                      onChange={() => dispatch(ANYActions.changeReplacement(!replacement))}
                    />
                  }
                  label={<Typography>Replacement</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="accident-new-york-policy-number"
                  label="Policy Number"
                  variant="outlined"
                  placeholder="Enter Policy Number"
                  margin="normal"
                  fullWidth
                  error={showPolicyNumberError}
                  helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                  className="product-riders-section__policy-type__form__row--field"
                  value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                  onBlur={() => setPolicyNumberBlurred(true)}
                  onChange={event => dispatch(ANYActions.changePolicyNumber(event.target.value as string))}
                  disabled={!replacement}
                  inputProps={{
                    maxLength: 10,
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </div>
    </>
  );
};

export default AccidentNewYork;
